import LegModal from "./LegsModal";

export default LegModal;
